import { useRef, useState } from "react";
import { Banknote, CheckCircle2, StickyNote } from "lucide-react";

const THRESHOLD = 80;
const REVEAL = 132;

export default function SwipeCard({ children, onSwipeRight, onComplete, onNote, testid, canPay = true, canComplete = true }) {
  const [dx, setDx] = useState(0);
  const [drag, setDrag] = useState(false);
  const start = useRef(null);
  const moved = useRef(false);

  const down = (e) => {
    if (e.pointerType === "mouse") e.preventDefault();
    start.current = { x: e.clientX, y: e.clientY, base: dx, id: e.pointerId, el: e.currentTarget }; moved.current = false;
  };
  const move = (e) => {
    if (!start.current) return;
    const ddx = e.clientX - start.current.x;
    if (!drag && Math.abs(ddx) < 8) return;
    if (!drag && Math.abs(e.clientY - start.current.y) > Math.abs(ddx)) { start.current = null; return; }
    if (!moved.current) { try { start.current.el.setPointerCapture(start.current.id); } catch { /* noop */ } }
    moved.current = true; setDrag(true);
    let v = start.current.base + ddx;
    if (!canPay) v = Math.min(v, 0);
    setDx(Math.max(-REVEAL - 20, Math.min(v, 140)));
  };
  const up = () => {
    if (!start.current) return;
    start.current = null; setDrag(false);
    if (dx > THRESHOLD && canPay) { setDx(0); onSwipeRight?.(); return; }
    setDx(dx < -THRESHOLD / 1.5 ? -REVEAL : 0);
  };
  const clickCapture = (e) => { if (moved.current) { e.stopPropagation(); e.preventDefault(); moved.current = false; } };
  const act = (fn) => () => { setDx(0); fn?.(); };

  return (
    <div className="relative overflow-hidden rounded-2xl select-none" data-testid={testid}>
      <div className={`absolute inset-0 flex items-center pl-4 text-white text-xs font-bold gap-1.5 bg-[#10B981] transition-opacity ${dx > 10 ? "opacity-100" : "opacity-0"}`}>
        <Banknote className="w-4 h-4" /> {dx > THRESHOLD ? "Relâchez : encaissé" : "Encaisser"}
      </div>
      <div className={`absolute inset-y-0 right-0 flex transition-opacity ${dx < -10 ? "opacity-100" : "opacity-0 pointer-events-none"}`}>
        {canComplete && <button onClick={act(onComplete)} data-testid={`${testid}-complete`} className="w-[66px] bg-orange-500 text-white text-[10px] font-bold flex flex-col items-center justify-center gap-1"><CheckCircle2 className="w-4 h-4" /> Terminé</button>}
        <button onClick={act(onNote)} data-testid={`${testid}-note`} className={`${canComplete ? "w-[66px]" : "w-[132px]"} bg-primary text-primary-foreground text-[10px] font-bold flex flex-col items-center justify-center gap-1`}><StickyNote className="w-4 h-4" /> Note</button>
      </div>
      <div onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up} onClickCapture={clickCapture}
        style={{ transform: `translateX(${dx}px)`, touchAction: "pan-y" }}
        className={`relative ${drag ? "" : "transition-transform duration-300 ease-out"}`}>
        {children}
      </div>
    </div>
  );
}
